module.exports = __webpack_public_path__ + "static/media/dots_loading.236c5ce5.svg";